import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import QuoteStartIcon from '../../../../public/static/icons/quote-start.svg';

export const StyledComponentWrapper = styled.div`
    flex-grow: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
`;

export const StyledGalleryWrapper = styled.div`
    flex-grow: 0;
    width: 100%;
`;

export const StyledTestimonialWrapper = styled.div`
    padding: 0 40px;
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const StyledContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    margin-top: 21px;
    text-align: center;
    flex: 1;
`;

export const StyledTestimonialText = styled.p`
    font-size: ${(props) => props.theme.fontSize.headlineS};
    line-height: 1.3;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.headlineS};
    }
    @media ${mediaQueries.smallDesktopAndUp} {
        font-size: ${(props) => props.theme.fontSize.headlineM};
        line-height: 1.29;
    }
`;

export const StyledTestimonialName = styled.span`
    font-size: 10px;
    color: ${(props) => props.theme.shades.midGrey};
`;

export const StyledQuoteIcon = styled(({ startQuote, ...rest }: { startQuote: boolean }) => (
    <QuoteStartIcon {...rest} />
))`
    fill: #99afbf;
    width: 40px;
    flex-shrink: 0;

    ${(props) =>
        props.startQuote
            ? css`
                  align-self: flex-end;
                  margin-bottom: 7px;
              `
            : css`
                  align-self: flex-start;
                  transform: rotate(-180deg);
              `};
`;
